import i18n from "@/i18n";

const Tiles = {
    1: {
        icon: "far fa-coins",
        name: i18n.t("tiles.invoicing"),
        path: "/invoicing/contracts"
    },
    2: {
        icon: "far fa-stopwatch",
        name: i18n.t("tiles.registration"),
        path: "/start"
    },
    3: {
        icon: "far fa-users",
        name: i18n.t("tiles.hr")
    },
    4: {
        icon: "far fa-chart-line",
        name: i18n.t("tiles.development"),
        path: "/projects/portfolio"
    },
    5: {
        icon: "far fa-calculator",
        name: i18n.t("tiles.internal_finance"),
        path: "/invoicing/contracts"
    },
    6: {
        icon: "fas fa-wind-turbine",
        name: i18n.t("tiles.own_assets"),
        path: "CUSTOM_FULL_MB"
    },
    7: {
        icon: "far fa-tools",
        name: i18n.t("tiles.services"),
        path: "/projects/turbine-stops"
    },
    8: {
        icon: "far fa-users-cog",
        name: i18n.t("tiles.asset_management"),
        path: "/reports/contracts"
    },
    9: {
        icon: "far fa-chart-bar",
        name: i18n.t("tiles.statistics"),
        path: "/reports/mb-report/spot-prices"
    },
    10: {
        icon: "far fa-file-chart-pie",
        name: i18n.t("tiles.management_report")
    },
    11: {
        icon: "far fa-database",
        name: i18n.t("tiles.raw_data_output")
    },
    12: {
        icon: "far fa-wrench",
        name: i18n.t("tiles.maintenance_access")
    }
};

export { Tiles };
